import { Component, OnInit, ViewChild } from "@angular/core";
import { first, startWith, catchError, map, switchMap  } from "rxjs/operators";
import { ChartViewDTO } from "../../core/model/chart_view/chart-view-dto";
import * as Highcharts from "highcharts";
import { DashboardProvisionServiceService } from '../../core/service/suiviPortefeuille/dashboard-provision-service.service';
import { DashboardCreanceService } from '../../core/service/suiviPortefeuille/dashboard-creance.service';
import { QuantiteDossierPrecontentieuxDTO } from '../../core/model/QuantiteDossierPrecontentieuxDTO';
import { merge, Observable, of as observableOf } from "rxjs";

import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { DossierDTO } from 'src/app/suivi-portefeuille/core/model/DossierDTO';




@Component({
  selector: "app-dossier-provison",
  templateUrl: "./dossier-provison.component.html",
  styleUrls: ["./dossier-provison.component.scss"]
})
export class DossierProvisonComponent implements OnInit {
  highcharts = Highcharts;
  dossiers: DossierDTO[];

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  nombreCumulByPeriode: ChartViewDTO;
  chartOptionsCumulSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  evolutionNombreByPeriode: ChartViewDTO;
  chartOptionsSuivievolutionNombreByPeriode: any;

  quantiteDossierPrecontentieuxDTO: QuantiteDossierPrecontentieuxDTO[];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = [
    "numDossier",
    "typeDossier",
    "bankLabel",
    "nomClient",
    "createdAt",
    "montantPret",
    "resteAPayer",
    "pourcentageNonCouvert",
    "pourcentagePartieRestante",
    "pourcentageTotal",
    "provisionNonCouvert",
    "provisionPartieRestante",
    "provisionTotal",
    "impayeJour"
  ];

  constructor(
    private _dashboardProvisionServiceService: DashboardProvisionServiceService
  ) {}

  ngOnInit() {
    this.nombreDossierContentieuxProvision();
    this.quantiteDossierProvision6DerniersMois();
    this.quantiteDossierPrecontentieux();
    this.getPageDossier("_", 0);
  }

  ngAfterViewInit(): void {
    this.getPageDossier("_", 0);
  }

  nombreDossierContentieuxProvision() {
    this._dashboardProvisionServiceService
      .nombreDossierProvions()
      .pipe(first())
      .subscribe(
        response => {
          this.evolutionNombreByPeriode = response;

          this.chartOptionsSuivievolutionNombreByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text:
                "Somme des montants de provision par mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.evolutionNombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Montant"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.evolutionNombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierProvision6DerniersMois() {
    this._dashboardProvisionServiceService
      .quantiteDossierParMarcheSurLes6DerniersMois()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text:
                "Evolution des provisions par marché sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierPrecontentieux() {
    this._dashboardProvisionServiceService
      .quantiteDossierProvision()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierPrecontentieuxDTO = response;
        },
        error => {
          console.log(error);
        }
      );
  }

  getPageDossier(filter: string, pageIndex: number): void {
    if (!this.sort || !this.paginator) {
      console.error("MatSort ou MatPaginator non initialisé.");
      return;
    }

    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = pageIndex;
    });

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this._dashboardProvisionServiceService.findAllPagingDossierProvision(
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;
          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe(data => {
        this.dossiers = data;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPageDossier(filterValue, 0);
  }
}
